var exports = {
  "kL": "xe533113f--32c0c4--container",
  "DD": "xe533113f--32c0c4--title",
  "M3": "xe533113f--32c0c4--metro-icon",
  "kP": "xe533113f--32c0c4--distance-container",
  "Io": "xe533113f--32c0c4--distance",
  "aR": "xe533113f--32c0c4--time-walk",
};

module.exports = exports;
